<template>
  <el-dialog
    title="机器人管理"
    :visible.sync="dialogVisible"
    v-model="dialogVisible"
    :close-on-click-modal="false"
    custom-class="minheight"
  >
    <!--工具条-->
    <Toolbar
      :buttonList="buttonList"
      @callFunction="callFunction"
      :selectBut="false"
    ></Toolbar>
    <!--列表-->
    <el-table
      ref="listTable"
      :data="list"
      highlight-current-row
      v-loading="listLoading"
      @current-change="selectCurrentRow"
      style="width: 100%"
    >
      <el-table-column :label="$t('Cover')" width="100">
        <template slot-scope="scope">
          <div
            v-if="scope.row.Cover != null && scope.row.Cover != ''"
            class="usercover"
            :style="{
              backgroundImage: 'url(' + baseCoverUrl + scope.row.Cover + ')',
            }"
          ></div>
        </template>
      </el-table-column>
      <el-table-column :label="$t('Name')">
        <template slot-scope="scope">{{ scope.row.UserName }}</template>
      </el-table-column>
    </el-table>

    <!--新增-->
    <el-dialog
      :title="$t('add')"
      :visible.sync="addFormVisible"
      v-model="addFormVisible"
      :close-on-click-modal="false"
      append-to-body
      width="35%"
    >
      <el-form :model="addForm" label-width="150px" ref="addForm" size="small">
        <el-form-item
          label="数量"
          prop="number"
          :rules="{
            required: true,
            message: $t('pleaseEnter') + '数量',
          }"
        >
          <el-input
            type="number"
            v-model.number="addForm.number"
            style="width: 200px"
          ></el-input>
        </el-form-item>
        <el-form-item label="是否通知">
          <el-switch v-model="addForm.isInform"></el-switch>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click.native="addFormVisible = false">{{
          $t("cancel")
        }}</el-button>
        <el-button
          type="primary"
          @click.native="addSubmit"
          :loading="addLoading"
          >{{ $t("submit") }}</el-button
        >
      </div>
    </el-dialog>

    <div slot="footer" class="dialog-footer"></div>
  </el-dialog>
</template>

<script>
import util from "util/date";
import {
  base,
  getDummyList,
  addTourDiyDummy,
  removeTourDiyDummy,
} from "@/api/api";
import { getButtonList } from "@/promissionRouter";
export default {
  data() {
    return {
      baseCoverUrl: base,
      buttonList: [],
      list: [],
      listLoading: false,
      currentRow: null,
      dialogVisible: false,
      tid: 0,
      //新增界面数据
      addFormVisible: false,
      addLoading: false,
      addForm: { id: 0, number: 0, isInform: true },
    };
  },
  inject: ["getTourDiyList"],
  methods: {
    formatDate: function (val) {
      return util.formatDate.format(new Date(val), "yyyy/MM/dd hh:mm");
    },
    selectCurrentRow(val) {
      this.currentRow = val;
    },
    callFunction(item) {
      this[item.Func].apply(this, item);
    },
    //显示新增界面
    handleAdd() {
      this.addFormVisible = true;
      this.addForm = {
        id: this.tid,
        number: 0,
        isInform: true,
      };
    },
    //新增活动
    addSubmit: function () {
      let _this = this;
      if (this.addForm.number <= 0) {
        this.$message({
          message: "请输入数量",
          type: "error",
        });
        return;
      }
      this.$refs.addForm.validate((valid) => {
        if (valid) {
          this.$confirm(this.$t("submitPrompt"), this.$t("prompt"), {})
            .then(() => {
              this.addLoading = true;
              let para = Object.assign({}, this.addForm);
              addTourDiyDummy(para).then((res) => {
                this.addLoading = false;
                if (util.isEmt.format(res)) {
                  return;
                }
                if (res.data.success) {
                  this.$message({
                    message: res.data.msg,
                    type: "success",
                  });
                  this.$refs["addForm"].resetFields();
                  this.addFormVisible = false;
                  this.getTourDiyList();
                  this.getList();
                } else {
                  this.$message({
                    message: res.data.msg,
                    type: "error",
                  });
                }
              });
            })
            .catch(() => {});
        }
      });
    },
    //删除
    handleDel() {
      let row = this.currentRow;
      if (!row) {
        this.$message({
          message: this.$t("selectRow"),
          type: "error",
        });

        return;
      }
      this.$confirm(this.$t("deletePrompt"), this.$t("prompt"), {
        type: "warning",
      })
        .then(() => {
          this.listLoading = true;
          let para = { id: row.Id };
          removeTourDiyDummy(para).then((res) => {
            this.listLoading = false;
            if (util.isEmt.format(res)) {
              return;
            }
            if (res.data.success) {
              this.getTourDiyList();
              this.$message({
                message: this.$t("deleteSuccess"),
                type: "success",
              });
            } else {
              this.$message({
                message: res.data.msg,
                type: "error",
              });
            }

            this.getList();
          });
        })
        .catch(() => {});
    },
    //获取列表
    getList() {
      let _this = this;
      this.listLoading = true;
      let para = {
        id: this.tid,
      };
      getDummyList(para).then((res) => {
        this.list = res.data.response;
        this.listLoading = false;
      });
    },
    loadData(id) {
      this.tid = id;
      this.getList();
      this.dialogVisible = true;
      let routers = window.localStorage.router
        ? JSON.parse(window.localStorage.router)
        : [];
      this.buttonList = getButtonList("/Order/TourDiyDummy", routers);
    },
  },
};
</script>
